import { EMPTY_SIM, isMobileProduct, type SimLine } from '../lib/simLines'
import { Button, FormSection, Select, TextField } from './ui'

/**
 * SIM della pratica (Fastweb): ognuna diventa una pratica collegata alla principale e su Teamwork una pratica dello
 * stesso gruppo. Obbligatorie per un bundle F+M (almeno una SIM BUNDLE).
 */
export function PraticaSimSection({ sims, onChange, products, disabled }: {
  sims: SimLine[]
  onChange: (sims: SimLine[]) => void
  products: { id: number; name: string }[]
  disabled?: boolean
}) {
  const mobile = products.filter(p => isMobileProduct(p.name))
  const patch = (i: number, p: Partial<SimLine>) => onChange(sims.map((s, j) => (j === i ? { ...s, ...p } : s)))
  return (
    <FormSection title="SIM" className="mt-4" columns={1}
      description="Per un bundle F+M o per aggiungere SIM al fisso: ogni SIM diventa una pratica collegata.">
      {sims.map((s, i) => (
        <div key={i} className="d-flex flex-wrap gap-3 align-items-end">
          <div style={{ minWidth: 260 }}>
            <Select id={`sim-${i}-product`} label={`SIM ${i + 1}: prodotto`} value={s.productId} disabled={disabled}
              onChange={e => patch(i, { productId: e.target.value })}>
              <option value="">Seleziona…</option>
              {mobile.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </Select>
          </div>
          <Select id={`sim-${i}-attivazione`} label="Attivazione" value={s.attivazione} disabled={disabled}
            onChange={e => patch(i, { attivazione: e.target.value })}>
            <option value="NUOVA">Nuova SIM</option>
            <option value="PORTABILITA">Portabilità</option>
          </Select>
          {s.attivazione === 'PORTABILITA' && <>
            <TextField id={`sim-${i}-numero`} label="Numero da portare" type="tel" value={s.numero} disabled={disabled}
              onChange={e => patch(i, { numero: e.target.value })} />
            <TextField id={`sim-${i}-gestore`} label="Gestore di provenienza" value={s.gestore} disabled={disabled}
              onChange={e => patch(i, { gestore: e.target.value })} />
          </>}
          <Select id={`sim-${i}-membership`} label="Tipo" value={s.membership} disabled={disabled}
            onChange={e => patch(i, { membership: e.target.value })}>
            <option value="ABBONAMENTO">Abbonamento</option>
            <option value="RICARICABILE">Ricaricabile</option>
          </Select>
          <TextField id={`sim-${i}-iccid`} label="ICCID (seriale SIM)" value={s.iccid} disabled={disabled}
            onChange={e => patch(i, { iccid: e.target.value })} />
          <Button type="button" variant="text" disabled={disabled} onClick={() => onChange(sims.filter((_, j) => j !== i))}>Togli</Button>
        </div>
      ))}
      <div>
        <Button type="button" variant="tonal" disabled={disabled} onClick={() => onChange([...sims, { ...EMPTY_SIM }])}>Aggiungi SIM</Button>
      </div>
    </FormSection>
  )
}
